import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Page } from '../domain/page.model';
import { Segment } from '../domain/supply-marketplace.model';
import { HttpUtils } from '../utils/http-utils';
import { first, map } from 'rxjs/operators';
import { MixpanelService } from './mixpanel.service';
import { MixpanelEvents } from '../analytics/mixpanel-events';
import { withMixpanelOutcome } from '../analytics/mixpanel-tracking.utils';

@Injectable({
  providedIn: 'root',
})

export class SupplyMarketplaceService {

  constructor(
    private httpClient: HttpClient,
    private mixpanel: MixpanelService
  ) {
  }

  getSegmentByID(segmentId: string): Observable<Segment> {
    return this.httpClient.get<Segment>(`${environment.serviceUrl}/api/app-segment/${segmentId}`);
  }

  createSegment(segment: Segment): Observable<Segment> {
    return this.httpClient
      .post<Segment>(`${environment.serviceUrl}/api/app-segment`, segment)
      .pipe(
        withMixpanelOutcome(this.mixpanel, {
          successEvent: MixpanelEvents.MarketplaceSegmentCreated,
          failureEvent: MixpanelEvents.MarketplaceSegmentCreateFailed,
          successProps: (created) => ({
            segment_id: created?.id,
            segment_name: created?.name,
          }),
          failureProps: () => ({
            segment_name: segment?.name,
          }),
        })
      );
  }

  updateSegment(segment: Segment): Observable<Segment> {
    return this.httpClient.put<Segment>(`${environment.serviceUrl}/api/app-segment/${segment.id}`, segment);
  }

  getSegments(filter?: any): Observable<Page<Segment>> {
    return this.httpClient.get<Page<Segment>>(`${environment.serviceUrl}/api/app-segment`, {
      params: HttpUtils.getHttpParams(filter)
    });
  }

  getSegmentsStatuses(filter?: any): Observable<Page<Segment>> {
    return this.httpClient.get<Page<Segment>>(`${environment.serviceUrl}/api/app-segment/count-by-status`, {
      params: HttpUtils.getHttpParams(filter)
    });
  }

  getAppsForSegment(segment: Segment): Observable<any> {
    return this.httpClient.post<any>(`${environment.serviceUrl}/api/app-segment/apps`, segment);
  }


  uploadAppsCsv(file: File): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);

    return this.httpClient
      .post<any>(
        `${environment.serviceUrl}/api/app-segment/upload-apps`,
        formData
      )
      .pipe(first());
  }

  downloadAppsTemplateCsv(): Observable<Blob> {
    return this.httpClient
      .get<string>(
        `${environment.serviceUrl}/api/app-segment/apps-template`,
        {
          responseType: 'blob',
          header: {
            Accept: 'text/csv',
          },
        } as any
      )
      .pipe(
        map((response: any) => {
          const blob = new Blob([response], {
            type: 'text/csv',
          });
          return blob;
        })
      );
  }


}
